import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, AuthContext } from './context/AuthContext';
import Login from './modulos/login/Login';
import Diseno from './comun/Diseno';
import RequiereCajaAbierta from './comun/RequiereCajaAbierta';
import ListaUsuarios from './modulos/usuarios/ListaUsuarios';
import ServicePlaceholder from './components/ServicePlaceholder';
import PanelFastFood from './modulos/fast-food/PanelFastFood';
import Inventario from './modulos/fast-food/Inventario';
import Bodega from './modulos/fast-food/Bodega';
import Mezclas from './modulos/fast-food/Mezclas';
import Ordenes from './modulos/fast-food/Ordenes';
import Clientes from './modulos/fast-food/Clientes';
import Trabajadores from './modulos/fast-food/Trabajadores';
import Ganancias from './modulos/fast-food/Ganancias';
import Reportes from './modulos/fast-food/Reportes';
import PuntosVenta from './modulos/fast-food/PuntosVenta';
import TasaDeCambio from './modulos/fast-food/TasaDeCambio';
import PanelCaja from './modulos/fast-food/Caja/PanelCaja';
import Impresoras from './modulos/fast-food/Impresoras';
import Promociones from './modulos/fast-food/Promociones';
import Gastos from './modulos/fast-food/Gastos';
import Toppings from './modulos/fast-food/Toppings';
import Variables from './modulos/fast-food/Variables';
import ReportesPeriodicos from './modulos/fast-food/ReportesPeriodicos';
import FacturacionSRI from './modulos/fast-food/FacturacionSRI';
import LoncherasEscolares from './modulos/fast-food/LoncherasEscolares';
import Escuelas from './modulos/fast-food/Escuelas';
import CafeGrano from './modulos/fast-food/CafeGrano';
import PanelCobranzas from './modulos/cobranzas/PanelCobranzas';
import ConfiguracionSecuencia from './modulos/fast-food/ConfiguracionSecuencia';
import logo from './assets/logo.png';
import './App.css';

// Componente para proteger rutas
const PrivateRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return <div>Cargando...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return <Diseno>{children}</Diseno>;
};

const FastFoodRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) return <div>Cargando...</div>;
  if (!user) return <Navigate to="/login" />;

  // Usamos el diseño general para todos, la barra lateral filtrará los items
  return <Diseno>{children}</Diseno>;
};

// Componente para proteger la ruta de Cobranzas
const GestorCobranzasRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) return <div>Cargando...</div>;
  if (!user) return <Navigate to="/login" />;
  const roleName = user?.role_details?.name;
  // Solo el rol Gestor de Cobranzas entra a este panel (el administrador del negocio no)
  if (roleName !== 'GESTOR_COBRANZAS') {
    return <Navigate to="/" />;
  }

  return <Diseno>{children}</Diseno>;
};

// Dashboard simple
const Dashboard = () => {
  const { user } = useContext(AuthContext);
  const roleName = user?.role_details?.name;
  
  if (roleName === 'GESTOR_COBRANZAS') {
      return <Navigate to="/cobranzas" />;
  }

  if (roleName !== 'SUPER_ADMIN' && !user?.is_superuser) {
      return <Navigate to="/fast-food/pos" />;
  }

  return (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '80vh',
    backgroundColor: 'var(--surface-color)',
    color: 'var(--primary-color)',
    textAlign: 'center',
    borderRadius: '16px',
    padding: '3rem',
    margin: '1rem',
    border: '1px solid var(--border-color)',
    boxShadow: '0 4px 20px rgba(74, 31, 12, 0.08)'
  }}>
    <img src={logo} alt="Sophia´s Coffe" style={{ height: '180px', marginBottom: '2rem', objectFit: 'contain', filter: 'drop-shadow(0 4px 8px rgba(74, 31, 12, 0.1))' }} />
    <h2 style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '1rem', color: 'var(--primary-color)' }}>Bienvenido a Sophia´s Coffe</h2>
    <p style={{ fontSize: '1.2rem', color: 'var(--text-secondary)' }}>Seleccione una opción del menú lateral para comenzar a administrar su negocio.</p>
  </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route path="/" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />

          <Route path="/users" element={
            <PrivateRoute>
              <ListaUsuarios />
            </PrivateRoute>
          } />

          {/* Rutas de creación/edición eliminadas porque ahora son Modales */}

          <Route path="/fast-food" element={
            <FastFoodRoute>
              <PanelFastFood />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/loncheras" element={
            <FastFoodRoute>
              <RequiereCajaAbierta modulo="a Loncheras Escolares">
                <LoncherasEscolares />
              </RequiereCajaAbierta>
            </FastFoodRoute>
          } />
          <Route path="/fast-food/escuelas" element={
            <FastFoodRoute>
              <Escuelas />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/cafe-grano" element={
            <FastFoodRoute>
              <RequiereCajaAbierta modulo="a Café en Grano / Peso">
                <CafeGrano />
              </RequiereCajaAbierta>
            </FastFoodRoute>
          } />
          <Route path="/fast-food/inventory" element={
            <FastFoodRoute>
              <Inventario />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/toppings" element={
            <FastFoodRoute>
              <Toppings />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/variables" element={
            <FastFoodRoute>
              <Variables />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/promotions" element={
            <FastFoodRoute>
              <Promociones />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/bodega" element={
            <FastFoodRoute>
              <Bodega />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/mezclas" element={
            <FastFoodRoute>
              <Mezclas />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/orders" element={
            <FastFoodRoute>
              <Ordenes />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/customers" element={
            <FastFoodRoute>
              <Clientes />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/workers" element={
            <FastFoodRoute>
              <Trabajadores />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/ganancias" element={
            <FastFoodRoute>
              <Ganancias />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/reports" element={
            <FastFoodRoute>
              <Reportes />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/periodic-reports" element={
            <FastFoodRoute>
              <ReportesPeriodicos />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/pos" element={
            <FastFoodRoute>
              <PuntosVenta />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/tasa-cambio" element={
            <FastFoodRoute>
              <TasaDeCambio />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/shift" element={
            <FastFoodRoute>
              <PanelCaja />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/feria-shift" element={
            <FastFoodRoute>
              <PanelCaja isFeriaMode={true} />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/gastos" element={
            <FastFoodRoute>
              <Gastos />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/facturacion-sri" element={
            <FastFoodRoute>
              <FacturacionSRI />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/printers" element={
            <FastFoodRoute>
              <Impresoras />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/secuencia" element={
            <FastFoodRoute>
              <ConfiguracionSecuencia />
            </FastFoodRoute>
          } />


          <Route path="/cobranzas" element={
            <GestorCobranzasRoute>
              <PanelCobranzas />
            </GestorCobranzasRoute>
          } />

          <Route path="/hotel" element={
            <PrivateRoute>
              <ServicePlaceholder title="Hotel" />
            </PrivateRoute>
          } />

          <Route path="/pool" element={
            <PrivateRoute>
              <ServicePlaceholder title="Piscinas" />
            </PrivateRoute>
          } />

          <Route path="/restaurant" element={
            <PrivateRoute>
              <ServicePlaceholder title="Restaurante" />
            </PrivateRoute>
          } />

          {/* Redirigir cualquier otra ruta al inicio */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
